import type { ReactElement } from 'react';
import { Briefcase, Inbox } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/shell/PageHeader';
import { PageWithSidebar } from '@/components/shell/PageWithSidebar';
import { Sidebar, type SidebarGroup } from '@/components/shell/Sidebar';
import { MyCasesInbox } from '@/features/my-cases/components/MyCasesInbox';

/**
 * Landing page after sign-in. The Inbox lists the signed-in user's tasks
 * across every patient they can see (PTV2-1236, backed by GET /persons/tasks);
 * the "Starred" list is still scaffolding pending PTV2-916.
 */
export function MyCasesPage(): ReactElement {
  const { t } = useTranslation();

  const groups: readonly SidebarGroup[] = [
    {
      key: 'lists',
      heading: t('routes.myCases.sidebar.heading'),
      items: [
        {
          key: 'inbox',
          label: t('routes.myCases.sidebar.inbox'),
          to: '/my-cases',
          icon: <Inbox className="h-4 w-4" aria-hidden="true" />,
        },
      ],
    },
  ];

  return (
    <PageWithSidebar sidebar={<Sidebar groups={groups} />}>
      <PageHeader
        icon={<Briefcase className="h-[18px] w-[18px]" aria-hidden="true" />}
        title={t('routes.myCases.heading')}
        subtitle={t('routes.myCases.subheading')}
      />
      <MyCasesInbox />
    </PageWithSidebar>
  );
}
